import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
// import Test from './pages/Test';
import Auth from './pages/Auth';
import Nav from './global/Nav';
import Lost from './pages/Lost';
import CatsHome from './pages/CatsHome';
import MerchantPage from './pages/MerchantPage';
import AccessionPage from './pages/accessions/AccessionPage';
import AssetPage from './pages/AssetPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ItemPage from './pages/ItemPage';
import ChangeStatusPage from './pages/ChangeStatusPage';
import AdminPage from './pages/AdminPage';
import ProtectedRoute from './components/ProtectedRoute';
import BrowsePage from './pages/BrowsePage';
import SearchResults from './pages/search-results/SearchResults';

const App = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="App">
      {user ? (
        <>
          <Nav />
          <Routes>
            <Route path="/" element={<Navigate to="/cats" replace />} />
            <Route path="/cats" element={<CatsHome />} />
            <Route path="/lost" element={<Lost />} />
            <Route path="/cats/admin" element={<ProtectedRoute element={AdminPage} allowedRoles={['admin']} />} />
            {/* <Route path="/cats/admin/test" element={<ProtectedRoute element={Test} allowedRoles={['admin']} />} /> */}
            <Route path="/cats/merchant" element={<ProtectedRoute element={MerchantPage} allowedRoles={['admin', 'merchant']} />} />
            <Route path="/cats/merchant/accession" element={<ProtectedRoute element={AccessionPage} allowedRoles={['admin', 'merchant']} />} />
            <Route path="/cats/merchant/assets" element={<ProtectedRoute element={AssetPage} allowedRoles={['admin', 'merchant']} />} />
            <Route path="/cats/merchant/analytics" element={<ProtectedRoute element={AnalyticsPage} allowedRoles={['admin', 'merchant']} />} />
            <Route path="/cats/merchant/assets/edit/:itemId" element={<ProtectedRoute element={AccessionPage} allowedRoles={['admin', 'merchant']} />} />
            <Route path="/cats/merchant/assets/status/:itemId" element={<ProtectedRoute element={ChangeStatusPage} allowedRoles={['admin', 'merchant']} />} />
            <Route path="/cats/search/:query" element={<ProtectedRoute element={SearchResults} allowedRoles={['admin', 'merchant', 'user']} />} />
            <Route path="/cats/item/:itemId" element={<ProtectedRoute element={ItemPage} allowedRoles={['admin', 'merchant', 'user']} />} />
            <Route path="/cats/browse" element={<ProtectedRoute element={BrowsePage} allowedRoles={['admin', 'merchant', 'user']} />} />
            <Route path="*" element={<Navigate to="/lost" replace />} />
          </Routes>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<Auth />} />
          <Route path="/register" element={<Auth />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </div>
  );
}

export default App;
